import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface TypographyProps {
  children: ReactNode;
  className?: string;
}

interface TextProps extends TypographyProps {
  variant?: 'body' | 'bodySmall' | 'secondary' | 'caption' | 'overline';
}

export function H1({ children, className, ...props }: TypographyProps) {
  return (
    <h1 className={cn('heading-1', className)} {...props}>
      {children}
    </h1>
  );
}

export function H2({ children, className, ...props }: TypographyProps) {
  return (
    <h2 className={cn('heading-2', className)} {...props}>
      {children}
    </h2>
  );
}

export function H3({ children, className, ...props }: TypographyProps) {
  return (
    <h3 className={cn('heading-3', className)} {...props}>
      {children}
    </h3>
  );
}

export function Text({ 
  children, 
  className, 
  variant = 'body',
  ...props 
}: TextProps) {
  const variantClassMap = {
    body: 'text-body',
    bodySmall: 'text-body-small',
    secondary: 'text-secondary',
    caption: 'text-caption',
    overline: 'text-overline'
  };

  return (
    <p className={cn(variantClassMap[variant], className)} {...props}>
      {children}
    </p>
  );
}

// Legacy Title component - for backward compatibility
export function Title({ children, className, ...props }: TypographyProps) {
  return (
    <h3 className={cn('heading-2', className)} {...props}>
      {children}
    </h3>
  );
}

// Overline for labels, categories, etc.
export function Overline({ children, className, ...props }: TypographyProps) {
  return (
    <span className={cn('text-overline', className)} {...props}>
      {children}
    </span>
  );
}

// Label for form elements
export function Label({ children, className, ...props }: TypographyProps) {
  return (
    <label className={cn('text-secondary', 'block', className)} {...props}>
      {children}
    </label>
  );
} 